import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_ADDRESS_SEARCH_TRACK } from 'api/utilityActionTypes';

export default async function track(
  { state, utilityApiClient },
  { addressId, utilityPartnerId, searchInput, status },
) {
  typeCheck('addressId::Maybe PositiveNumber', addressId);
  typeCheck('utilityPartnerId::PositiveNumber', utilityPartnerId);
  typeCheck('searchInput::Maybe NonEmptyString', searchInput);
  typeCheck('status::NonEmptyString', status);

  const analyticsSessionId =
    state.get(['utilityUser', 'analyticsSessionId']) ||
    state.get(['analytics', 'analyticsSessionId']);

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_ADDRESS_SEARCH_TRACK,
    state: state,
    payload: {
      addressId,
      utilityPartnerId,
      searchInput,
      status,
      analyticsSessionId,
    },
  });
}
